export const createShouldCostModelRoutes = {
  getModelData: 'v1/injection-molding/get-model-details',
  getRawMaterialDropdownData: 'v1/injection-molding/get-raw-material-dropdown',
  getCountries: 'v1/conversion/countries',
  saveModel: 'v1/injection-molding/create-new-model',
  getUnitsData: 'v1/injection-molding/get-units-dropdown',
  packagingData: 'v1/injection-molding/get-packaging-dropdown',
}

export const injectionModelingOverviewApiRoutes = {
  getKPIs: 'v1/injection-molding/get-kpi',
  getModelsTable: 'v1/injection-molding/get-all-models',
}
